import { IconCheck, IconX } from '@tabler/icons-react';
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';

const CreateNewAccessPresetModal = ({ buttonComponent, accessList, defaultName, callback, defaultSelectedCodes }) => {

    const [show, setShow] = useState(false);
    const [selectedAccessCodes, setSelectedAccessCodes] = useState(defaultSelectedCodes || []);

    useEffect(() => {
        if (show) {
            setSelectedAccessCodes(defaultSelectedCodes)
        }
    }, [defaultSelectedCodes, show]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const onSelectedAccessCodes = (accessCodeData) => {
        if (selectedAccessCodes.includes(accessCodeData.code)) {
            setSelectedAccessCodes(selectedAccessCodes.filter(code => code !== accessCodeData.code));
        } else {
            setSelectedAccessCodes([...selectedAccessCodes, accessCodeData.code]);
        }
    }

    async function createPreset() {
        let postData = {
            "presetName": document.getElementById('preset-name').value,
            "accessCodes": selectedAccessCodes
        }
        if (!postData?.presetName) {
            toast.error('Please enter a preset name.');
            return;
        }
        if (postData.accessCodes?.length < 1) {
            toast.error('Please select at least one access codes.');
            return;
        } else {
            loadingShow();
            let resp = await postApi(postData, urlApi.createAccessPreset);
            loadingHide();
            if (resp.responseCode === 200) {
                toast.success(resp?.message);
                callback?.()
                handleClose();
            } else {
                toast.error(resp.message);
            }
            setSelectedAccessCodes([]);
        }
    }

    return (
        <>
            <div className='w-max' onClick={handleShow}>{buttonComponent}</div>

            <Modal show={show} onHide={handleClose} size='xl' backdrop="static">
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold">Create New Access Preset</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <div className="block">
                        <label htmlFor="preset-name" className='text-sm font-semibold mb-1.5'>Preset Name (required)</label>
                        <input type="text" id="preset-name" className="w-full p-2 rounded-md border-2 text-sm" placeholder="Enter your preset name" defaultValue={defaultName} />
                    </div>
                    <p className='mb-3 text-sm font-light text-center text-orange-600 italic'> select access codes as per the access preset </p>
                    <div className='px-4 max-h-[75vh] overflow-y-auto'>
                        {
                            Object.entries(accessList).map(([key, value]) => (
                                <div key={key} className="mb-4">
                                    <p className="text-sm font-medium">{key}</p>
                                    <div className='ps-4 mt-2 flex flex-wrap items-center gap-3'>
                                        {
                                            value?.map((access, index) => (
                                                <div key={index} className={`cursor-pointer flex items-center border-2 px-3 py-1 rounded-lg text-sm gap-1 ${selectedAccessCodes?.includes(access?.code) ? 'border-green-500' : 'border-red-500'}`} onClick={() => onSelectedAccessCodes(access)}>
                                                    {access?.name} {selectedAccessCodes?.includes(access?.code) ? <IconCheck size={18} stroke={4} className='text-green-800' /> : <IconX size={18} stroke={4} className='text-red-800' />}
                                                </div>
                                            ))
                                        }
                                    </div>
                                </div>
                            ))
                        }
                    </div>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => createPreset()}>Create</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default CreateNewAccessPresetModal